"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportFilesClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
class ReportFilesClient {
    static newInstance(options, retryOptions) {
        return new ReportFilesClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions));
    }
    constructor(client) {
        this.client = client;
    }
    async findByDistrict(reportId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/reportFiles.findByDistrict`, {
            params: { reportId },
            headers,
            responseType: 'arraybuffer',
        });
        return response.body;
    }
    async findBySchool(reportId, schoolId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/reportFiles.findBySchool`, {
            params: { reportId, schoolId },
            headers,
            responseType: 'arraybuffer',
        });
        return response.body;
    }
    async download(reportId, enrollmentPeriodId, schoolId, assessmentTemplateId, headers) {
        const { body, headers: responseHeaders } = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/reportFiles.download`, {
            params: {
                reportId,
                schoolId,
                assessmentTemplateId,
                enrollmentPeriodId,
            },
            headers,
            responseType: 'arraybuffer',
        });
        const [, fileName] = responseHeaders['content-disposition'].split('"');
        return { buffer: body, fileName };
    }
    async exists(reportId, enrollmentPeriodId, schoolId, assessmentTemplateId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/reportFiles.exists`, {
            params: {
                reportId,
                schoolId,
                assessmentTemplateId,
                enrollmentPeriodId,
            },
            headers,
        });
        const { data } = response.body;
        return !!data.exists;
    }
}
exports.ReportFilesClient = ReportFilesClient;
//# sourceMappingURL=report-files.client.js.map